import { Tooltip } from "@faire/web--source/slate/Tooltip/index";
import { ITooltipProps } from "@faire/web--source/slate/Tooltip/Tooltip";
import React from "react";

import { TopShopTooltipContents } from "./TopShopTooltipContents";

export const TopShopEducationTooltip: React.FC<ITooltipProps> = ({
  position = "right",
  ...tooltipProps
}: ITooltipProps) => (
  <Tooltip position={position} width={310} {...tooltipProps}>
    <TopShopTooltipContents />
  </Tooltip>
);
